// Module
var code = "<div class=\"content-container\">\r\n    \r\n    <h2 data-bind=\"restext: 'HomeTitle'\"></h2>\r\n    <p data-bind=\"restext: 'HomeLeadText'\" class=\"lead\"></p>\r\n\r\n</div>\r\n";
// Exports
export default code;